var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5924 5.3335V6.51868H6.6665V8.88905H7.85169V24.2965C7.85169 24.9251 8.10142 25.528 8.54595 25.9726C8.99048 26.4171 9.5934 26.6668 10.2221 26.6668H22.0739C22.7026 26.6668 23.3055 26.4171 23.75 25.9726C24.1945 25.528 24.4443 24.9251 24.4443 24.2965V8.88905H25.6295V6.51868H19.7035V5.3335H12.5924ZM12.5924 11.2594H14.9628V21.9261H12.5924V11.2594ZM17.3332 11.2594H19.7035V21.9261H17.3332V11.2594Z",
    fill: "#B73D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6b629a78756e47afa030e54e61efe242.svg";
export { ForwardRef as ReactComponent };